import {
  useGetCurrentDepartmentTree,
  DepartmentTreeNodeDTO,
} from '@/api/trafikportalen';
import { useMemo } from 'react';

export const useFlattenDepartmentTree = (enabled: boolean = true) => {
  const { data: departmentTree, isLoading: flattenTreeLoading } =
    useGetCurrentDepartmentTree({
      query: {
        enabled,
      },
    });

  const flattenedDepartments = useMemo(() => {
    if (!departmentTree) return;

    const flattened: DepartmentTreeNodeDTO[] = [];

    const flattenTree = (department: DepartmentTreeNodeDTO) => {
      flattened.push({
        ...department,
        children: [],
      });

      if (department.children) {
        department.children.forEach(flattenTree);
      }
    };
    flattened.push({
      ...departmentTree,
      children: [],
    });
    departmentTree.children.forEach(flattenTree);

    return flattened;
  }, [departmentTree]);

  return { flattenedDepartments, flattenTreeLoading };
};
